import React from "react"
import * as Chakra from "@chakra-ui/react"
import {Link} from "gatsby";

interface ProjectSeeMoreProps {
    relatedItems?: { title?: string, url?: string }[]
    nextItem?: string
    nextItemUrl?: string
}

const ProjectSeeMore = React.forwardRef(({relatedItems, nextItem, nextItemUrl}: ProjectSeeMoreProps, ref) => {
  return (
    <Chakra.Box
      ref={ref}
      width="100%"
      display="flex"
      position="relative"
      alignItems="flex-start"
      flexDirection="column"
      backgroundColor="transparent"
    >
      <Chakra.Box
        display="flex"
        width="100%"
        height="100%"
        maxWidth="1800px"
        alignItems="flex-start"
        marginLeft="auto"
        paddingTop="49px"
        marginRight="auto"
        paddingLeft="40px"
        paddingRight="40px"
        flexDirection="column"
        paddingBottom="44px"
        backgroundColor="transparent"
        css={{
          "@media (max-width: 767px)": {
            paddingLeft: "20px",
            paddingRight: "20px",
          },
        }}
      >
        <Chakra.Box
          display="flex"
          width="100%"
          alignItems="flex-start"
          flexDirection="row"
          css={{
            "@media (max-width: 767px)": {
              flexDirection: "column",
            },
          }}
        >
          <Chakra.Box
            display="flex"
            width="50%"
            alignItems="flex-start"
            flexDirection="column"
            css={{
              "@media (max-width: 767px)": {
                paddingBottom: "50px",
              },
            }}
          >
            <Chakra.Box
              as="span"
              fontSize="18px"
              lineHeight="26px"
              paddingBottom="38px"
              css={{
                "@media (max-width: 991px)": {
                  fontFamily: "BeausiteClassic-Medium",
                },
              }}
            >
                See also
            </Chakra.Box>
            <Chakra.Box
              display="flex"
              alignItems="flex-start"
              flexDirection="column"
            >
                {relatedItems.map(({title, url}, index) => (
                    <Chakra.Box
                        color="currentColor"
                        opacity="0.5"
                        fontSize="18px"
                        lineHeight="26px"
                        key={index}
                        transition="0.3s"
                        _after={{
                            transition: "0.1s",
                            content: "''",
                            position: "absolute",
                            left: "0",
                            width: "100%",
                            opacity: "0",
                            height: "1px",
                            bottom: "0",
                            backgroundColor: "currentColor",
                        }}
                        _hover={{
                            opacity: 1,
                            "&:after": {
                                opacity: "1",
                            },
                        }}
                        css={{
                            "@media (max-width: 991px)": {
                                fontFamily: "BeausiteClassic-Clear",
                            },
                        }}
                        as={Link}
                        to={url}
                    >
                        {title}
                    </Chakra.Box>
                ))}
            </Chakra.Box>
          </Chakra.Box>
          <Chakra.Box
            display="flex"
            width="50%"
            alignItems="flex-start"
            flexDirection="column"
          >{nextItemUrl &&
              <>
              <Chakra.Box
              as="span"
              fontSize="18px"
              lineHeight="26px"
              paddingBottom="38PX"
              css={{
                "@media (max-width: 991px)": {
                  fontFamily: "BeausiteClassic-Medium",
                },
              }}
            >
              See next
            </Chakra.Box>
            <Chakra.Box
              display="flex"
              alignItems="flex-start"
              flexDirection="column"
            >
              <Chakra.Box
                color="currentColor"
                opacity="0.5"
                fontSize="18px"
                lineHeight="26px"
                transition="0.3s"
                _after={{
                    transition: "0.1s",
                    content: "''",
                    position: "absolute",
                    left: "0",
                    width: "100%",
                    opacity: "0",
                    height: "1px",
                    bottom: "0",
                    backgroundColor: "currentColor",
                }}
                _hover={{
                    opacity: 1,
                    "&:after": {
                        opacity: "1",
                    },
                }}
                css={{
                  "@media (max-width: 991px)": {
                    fontFamily: "BeausiteClassic-Clear",
                  },
                }}
                as={Link}
                to={nextItemUrl}
              >
                  {nextItem}
              </Chakra.Box>
            </Chakra.Box>
              </>}
          </Chakra.Box>
        </Chakra.Box>
      </Chakra.Box>
    </Chakra.Box>
  )
})

ProjectSeeMore.pressless = {
  name: "Project See More",
  attributes: {
      relatedItems: {
          name: "Related Items",
          type: "Repeater",
          attributes: {
              title: {
                  name: "Title",
                  type: "PlainText"
              },
              url: {
                  name: "URL",
                  type: "PlainText"
              },
          }
      },
      nextItem: {
          name: "Next Item Title",
          type: "PlainText"
      },
      nextItemUrl: {
          name: "Next Item URL",
          type: "PlainText"
      }
  },
}
export default ProjectSeeMore
